// src/pages/common/reports/R0006/constants.js

export const R0006_CONFIG = {
  REPORT_TITLE: "Efficiency & Productivity Report",
  MIN_WIDTH: '768px',
  MAX_WIDTH: '1200px',
  
  // Default theme - can be overridden by client configs
  HEADER_THEME: {
    backgroundColor: '#29261f',
    titleColor: '#cf9e0b',
    textColor: '#ffffff'
  },

  DEFAULT_AREA: "Area Summary",
  
  LOADING_TIMES: {
    SINGLE_DAY: 1500,
    MAX_RANGE: 3000,
    DELAY_PER_DAY: 200
  },

  KPI_CALCULATION_DELAY: 300,
  
  // Default business rules - can be overridden by client configs
  BUSINESS_RULES: {
    BASE_MULTIPLIER: {
      BRAND: 1,
      OTHER: 0.3
    },
    STORE_COUNTS: {
      BRAND: { total: 15, aboveTarget: 12 },
      OTHER: { total: 5, aboveTarget: 4 }
    }
  }
};